import React from "react";
import "./HorizontalLineRenderer.scss";

const HorizontalLineRenderer = ({ element }) => {
  const { properties = {} } = element;
  const { thickness = "1px", color = "#dadce0", style = "solid", margin = "20px" } = properties;

  const lineStyles = {
    borderTop: `${thickness} ${style} ${color}`,
    margin: `${margin} 0`,
  };

  return (
    <div className='horizontal-line-renderer my-2'>
      <hr className='horizontal-line w-100 m-0' style={lineStyles} />
    </div>
  );
};

export default HorizontalLineRenderer;
